import { Col, Descriptions, Divider, Input, Modal, Row } from "antd";
import DescriptionsItem from "antd/lib/descriptions/Item";
import { toUpdateStockInventory } from "../Pages/Achat/APIs";
import { successMsg } from "./Utils";
import { useEffect, useState } from "react";
import history from "./History";

const ConfStock = ({ initialList, location }) => {
  const [isModalVisible, setIsVisible] = useState(false);
  const [list, setList] = useState([]);

  useEffect(() => {
    if (initialList.length > 0) {
      setIsVisible(true);
      setList(initialList);
    }
  }, [initialList]);

  const toUpdateStock = () => {
    toUpdateStockInventory(list).then((res) => {
      successMsg("Synchronisation effectuée avec succès");
      setList([]);
      setIsVisible(false);
      if (location) {
        history.push(location);
      }
    });
  };

  const onChangeValue = (value, id) => {
    const l = [...list];
    l.map((el) => {
      el.list.map((item) => {
        if (item.id == id) {
          item.qte = parseInt(value) || 0;
        }
      });
    });
    setList(l);
  };
  return (
    <Modal
      title="Stock"
      visible={isModalVisible}
      onCancel={() => {
        setIsVisible(false);
        history.push(location);
      }}
      onOk={() => toUpdateStock(list)}
    >
      <div style={{ maxHeight: "60vh", overflowY: "scroll" }}>
        {list.map((el) => (
          <>
            <Descriptions>
              <DescriptionsItem label="Référence">{el.ref}</DescriptionsItem>
              <DescriptionsItem label="Article">{el.titre}</DescriptionsItem>
            </Descriptions>
            <Divider>Emplacements</Divider>
            {el.list.map((item) => (
              <>
                <Row gutter={[8, 8]}>
                  <Col span={6}>Emplacement</Col>
                  <Col span={4}>
                    <b>{item.emp}</b>
                  </Col>
                  <Col span={6}>Quantité</Col>
                  <Col span={4}>
                    <Input
                      onChange={(e) => onChangeValue(e.target.value, item.id)}
                      value={item.qte}
                    ></Input>
                  </Col>
                </Row>
              </>
            ))}
            <Divider />
          </>
        ))}
      </div>
    </Modal>
  );
};

export default ConfStock;
